module.exports = __webpack_public_path__ + "static/mstile-150x150-49befe342780870ab45ad7a2c80884b4.png";